// Export without redux connection
import MyCalendarPage from "./MyCalendarPage";

export default MyCalendarPage;
